export const GET_JOB= 'GET_JOB';
export const GET_JOB_ERR = 'GET_JOB_ERR';

export const GET_JOBS= 'GET_JOBS';
export const GET_JOBS_ERR = 'GET_JOBS_ERR';

export const GET_CAREER_CATEGORIES= 'GET_CAREER_CATEGORIES';
export const GET_CAREER_CATEGORIES_ERR = 'GET_CAREER_CATEGORIES_ERR';
